import { StyledChargesListControls } from './styles';
interface IChargesListControlsProps {
  children?: React.ReactNode;
}
export const ChargesListControls = ({ children }: IChargesListControlsProps) => {
  return <StyledChargesListControls>{children}</StyledChargesListControls>;
};
